import {TextField} from '@material-ui/core';
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {Dispatch} from 'redux';
import {localized} from '../../../../state/i18n/i18n';
import {showSuccess} from '../../../../state/snackbar/operations';
import {AppState} from '../../../../state/store';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getSnackbarSuccess: () => showSuccess(localized('YourChangesAreSaved'))(dispatch),
});

const mapStateToProps = (state: AppState) => {
  return {
    successStatus: state.notificationSettingsReducer.success,
  };
};

interface PropsFromParent {
  initialValue?: string;
  onChange: (value: string) => void;
}

interface State {
  value?: string;
}

type Props = Partial<ReturnType<typeof mapDispatchToProps>> &
  PropsFromParent &
  Partial<ReturnType<typeof mapStateToProps>>;

class DeviceManagementFieldString extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      value: this.props.initialValue,
    };
  }

  private setMeasurement = (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    this.setState({value: event.target.value});
  };

   private onChange = (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    this.props.onChange(event.target.value);
    this.props.getSnackbarSuccess && this.props.getSnackbarSuccess();
  };

  public render() {
    return (
      <TextField
        id="outlined-basic"
        variant="outlined"
        type="string"
        value={this.state.value}
        onChange={this.setMeasurement}
        onBlur={this.onChange}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DeviceManagementFieldString);
